import React from 'react';
import {hot} from 'react-hot-loader/root';
import PropTypes from 'prop-types';
import {
    Router,
    Route,
    Switch
} from 'react-router-dom';
import {getHistory} from 'store/store';
import AppDesktop from './AppDesktop';
import AppMobile from './AppMobile';

const App = ({
    isMobile
}) => {
    const AppComponent = (isMobile) ? AppMobile : AppDesktop;

    return (
        <Router history={getHistory()}>
            <Switch>
                <Route
                    path="/"
                    component={AppComponent}
                />
            </Switch>
        </Router>
    );
};

App.propTypes = {
    isMobile: PropTypes.bool
};

export default hot(App);
